import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Config } from '@config';
import { AuthHttp, HttpTokenService } from '@http';
import { UrlEnhancerService } from '@url';
import { lastValueFrom } from 'rxjs';

import SwaggerUI from 'swagger-ui';

@Component({
    templateUrl: './api.template.html',
    standalone: false
})
export class ApiComponent {
    public documentationUrl: string;
    public subscriptionLoaded: boolean = false;
    public subscription: any;

    public primaryKeyCopied: boolean = false;
    public secondaryKeyCopied: boolean = false;
    public primaryKeyCopiedTimeout: any = 0;
    public secondaryKeyCopiedTimeout: any = 0;

    private intervalNumber: any;
    private token: string;

    constructor(
        private http: AuthHttp,
        private tokenService: HttpTokenService,
        private config: Config,
        private urlEnhancerService: UrlEnhancerService,
        private router: Router
    ) { }

    async ngOnInit() {
        this.intervalNumber = setInterval(async() => {
            await this.renewToken();
        }, this.config.services.auth.renewInterval);
        this.renewToken();

        const url = this.urlEnhancerService.replaceParams(this.config.services.apiPortal.subscriptionKey);

        try {
            this.subscription = await lastValueFrom(this.http.getJSON(url));
        } catch(ex) {
            console.error(ex);
        } finally {
            this.subscriptionLoaded = true;
        }

        this.documentationUrl = this.urlEnhancerService.replaceParams(this.config.services.apiPortal.documentation);
        // documentation for swagger config can be found here: https://github.com/swagger-api/swagger-ui/blob/master/docs/usage/configuration.md
        SwaggerUI({
            domNode: document.getElementById('swagger-ui'),
            docExpansion: 'none',
            defaultModelsExpandDepth: 5,
            defaultModelExpandDepth: 3,
            tryItOutEnabled: true,
            url: this.documentationUrl,
            requestInterceptor: (req) => {
                if (req.url !== this.documentationUrl) {
                    req.headers.Authorization = 'bearer ' + this.token;
                    req.headers['Ocp-Apim-Subscription-Key'] = this.subscription.primaryKey;
                }
                
                return req;
            }
        });
    }

    ngOnDestroy() {
        clearInterval(this.intervalNumber);
    }

    copyKey(primary: boolean) {
        navigator.clipboard.writeText(primary ? this.subscription.primaryKey : this.subscription.secondaryKey);
        if (primary) {
            clearTimeout(this.primaryKeyCopiedTimeout);
            this.primaryKeyCopied = true;
            this.primaryKeyCopiedTimeout = setTimeout(() => this.primaryKeyCopied = false, 2000);
        } else {
            clearTimeout(this.secondaryKeyCopiedTimeout);
            this.secondaryKeyCopied = true;
            this.secondaryKeyCopiedTimeout = setTimeout(() => this.secondaryKeyCopied = false, 2000);
        }
    }

    download() {
        window.location.href = this.documentationUrl;
    }

    private async renewToken() {
        const tokenUrl = this.urlEnhancerService.replaceParams(this.config.services.apiPortal.token);
        this.token = await lastValueFrom(this.http.getJSON(tokenUrl));
    }
}